import { useState, useEffect } from 'react';
import { getDefaultTheme } from '@elliemae/pui-theme';
import type { Theme } from '@elliemae/pui-theme';

const theme = getDefaultTheme() as Theme;

const isMobile = (): boolean => {
  if (!window) return false;
  return Number(theme.breakpoints.medium.split('px')[0]) - window.innerWidth >= 0;
};

export const useIsMobile = (): boolean => {
  const [mobile, setMobile] = useState<boolean>(isMobile());

  useEffect(() => {
    function handleResize() {
      setMobile(isMobile());
    }
    window?.addEventListener('resize', handleResize);
    return () => {
      window?.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!window) return false;
  return mobile;
};
